import { render } from "./AvgAnswerTimeCard.vue?vue&type=template&id=377eb40c"
import script from "./AvgAnswerTimeCard.vue?vue&type=script&lang=js"
export * from "./AvgAnswerTimeCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__